import { NotificationManager } from "react-notifications";
import { Actions as INTEGRATION_ACTIONS } from "../../../../store/actions/integrationActions";
import { Actions as COMPANYACTIONS } from "../../../../store/actions/companyActions";

import { uniqBy } from "lodash";
import { createRequest } from "../../../common/helpers/RequestHelpers";
import apiURL from "@/store/actions/apiURL";
import axios from "axios";

const zktecoRequest = createRequest({
	urlPath: "/integrations/zkTeco",
	// local: true,
});

const integrationRequest = createRequest({
	urlPath: "/integrations",
	// local: true,
});

const Types = {
    ZKTECO_CONNECT: "ZKTECO_CONNECT",
    ZKTECO_GET_PUNCH_CLOCKS: "ZKTECO_GET_PUNCH_CLOCKS",
    ZKTECO_CONNECTED: "ZKTECO_CONNECTED",
    ZKTECO_SAVING: "ZKTECO_SAVING",
    ZKTECO_LOADING: "ZKTECO_LOADING",
}

const zktecoPunchClocks = (data) => ({
    type: Types.ZKTECO_GET_PUNCH_CLOCKS,
    data
})

const setZKTecoConnected = (response) => ({
    type: Types.ZKTECO_CONNECTED,
    response,
});

const setZKTecoSaving = (status) => ({
    type: Types.ZKTECO_SAVING,
    status,
})

const setZKTecoLoading = (status) => ({
    type: Types.ZKTECO_LOADING,
    status,
})

const connectZKTeco = (serialNumber) => {
    return (dispatch, getState) => {

        zktecoRequest({
            path: "/connect",
            method: "POST",
            body: { serialNumber }
        }).then(({ data }) => {
            dispatch(INTEGRATION_ACTIONS.integrationGetList());
            NotificationManager.success("ZK Teco connected successfully!", 'Connect ZK Teco')
        }).catch((error) => {
            console.error(error)
            NotificationManager.error("Error connecting ZK Teco", "Connect ZK Teco")
        })

        // fetch(`${apiURL}/integrations/zkTeco/connect`, {
        //     credentials: 'include',
        //     method: 'POST',
        //     body: JSON.stringify({ serialNumber }),
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json',
        //     },
        // })
        //     .then((res) => res.json())
    }
}

const getZKTecoPunchClocks = (serialNumber) => {
    return (dispatch, getState) => {
        dispatch(setZKTecoLoading(true))

        zktecoRequest({
            path: "/punch-clocks",
            method: "GET",
        }).then(({ data }) => {
            dispatch(zktecoPunchClocks(data))
            dispatch(setZKTecoLoading(false))
        }).catch((error) => {
            console.error(error.response)
            const errorToShow = error.response?.data?.error || "Getting ZK Teco Punch Clocks"
            NotificationManager.error(`Error: ${errorToShow}`, "ZK Teco")
            dispatch(setZKTecoLoading(false))
        })
    }
}


const disconnectZKTeco = () => {
    return (dispatch, getState) => {
        axios({
            method: 'POST',
            url: `${apiURL}/integrations/zkTeco/revoke`,
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })

    }
}

const updateZKTecoPunchClocks = (data, finalClock) => {
    return (dispatch, getState) => {
        dispatch(setZKTecoSaving(true));

        zktecoRequest({
            path: `/punch-clocks/${data.id}`,
            method: "POST",
            body: data
        }).then(({ data }) => {
            if (finalClock) {
                NotificationManager.success('ZK Teco Settings Saved Successfully', 'Saving ZK Teco Settings');
                dispatch(setZKTecoSaving(false));
            }
        }).catch((error) => {
            console.error(error);
            NotificationManager.error('Error Saving ZK Teco Settings', 'Saving ZK Teco Settings');
            if (finalClock) dispatch(setZKTecoSaving(false));
        })
    }
}

// const getPunchClocks = () => ({
//     type: Types.ZKTECO_GET_PUNCH_CLOCKS,
//     data: [{
//         "name": "My punch clock", 
//         "id": "serial number of punch clock",
//         "lastSeen": "last time the punchclock was recorded - ISO Format",
//         "location": "work location id",
//         "org": "organisation id",
//         "type": "ZK Teco or TimeMoto",
//         "skipDoublePunch": true,
//          "automatedBreaks": [
//          {
//           "duration": 40,
//           "hours": 11
//          },
//          {
//           "duration": 20,
//           "hours": 6
//          }
//         ],
//         "round": 5,
//         "roundEntryTime": [
//          {
//           "time": "07:00",
//           "weekdays": [
//            1,
//            2,
//            3,
//            4,
//            5
//           ]
//          }
//         ]
//        }]
// })

const Actions = {
    connectZKTeco,
    disconnectZKTeco,
    getZKTecoPunchClocks,
    updateZKTecoPunchClocks,
};

export { Actions, Types };
